import { createFileRoute, useNavigate } from "@tanstack/react-router";

import { RequestNewProviderScreen } from "@/components/features/AssignServiceProviderList/RequestNewProvider/RequestNewProviderScreen";

// 11.R: requesting a new provider is a different screen from selecting an
// existing one, so it renders in the centre pane of the assign layout with the
// provider list and the work order rail still beside it. It used to be a modal.
export const Route = createFileRoute(
  "/work-orders/$workOrderId/$visitId/assign-service-provider/_assignServiceProviderLayout/request-provider",
)({
  component: RequestProviderRoute,
});

function RequestProviderRoute() {
  const { workOrderId, visitId } = Route.useParams();
  const navigate = useNavigate();

  const backToList = () =>
    navigate({
      to: "/work-orders/$workOrderId/$visitId/assign-service-provider",
      params: { workOrderId, visitId },
    });

  // The provider was just accepted, so return to the Accepted tab with them
  // selected rather than to a list of candidates. Without the explicit tab the
  // list stays where it was: it never unmounts while this screen is open, so
  // its one-shot accepted default cannot fire again.
  const showAccepted = (serviceProviderId: string | undefined) =>
    navigate({
      to: "/work-orders/$workOrderId/$visitId/assign-service-provider",
      params: { workOrderId, visitId },
      state: (prev) => ({
        ...prev,
        activeTab: "accepted",
        ...(serviceProviderId ? { serviceProviderId } : {}),
      }),
    });

  return (
    <RequestNewProviderScreen visitId={visitId} onCancel={backToList} onSubmitted={showAccepted} />
  );
}
